import { FreeMode, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";

import { JSX, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import MovieBannerPlayer from "@/components/common/MovieBanner/MovieBannerPlayer.tsx";
import MovieBannerTitle from "@/components/common/MovieBanner/MovieBannerTitle.tsx";
import MovieBannerTop from "@/components/common/MovieBanner/MovieBannerTop.tsx";
import MainHeroButtons from "@/components/main/MainHero/MainHeroButtons.tsx";

import { ROUTES } from "@/config/routes";
import { useGetBanners } from "@/hooks/api/content.hooks.ts";
import { isSafari } from "@/utils/constatns";

import "./styles.css";

const MainHero = (): JSX.Element => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const { data: banners } = useGetBanners();

  const swiperRef = useRef<SwiperRef>(null);
  const navigate = useNavigate();

  const swiperBtnClass = "main-hero";

  const handleSlideChange = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  if (!banners) return <></>;

  const goToDetail = (id: number) => {
    navigate(ROUTES.DETAIL.MAIN.replace(":id", String(id)));
  };

  return (
    <section
      className={
        "main-hero relative  mt-6  rounded-3xl  max-xl:mt-4 max-lg:mb-[3.25rem] max-lg:overflow-visible max-md:aspect-auto"
      }
    >
      {!isSafari && (
        <canvas width={50} height={30} ref={canvasRef} className="ambient-canvas  aspect-[1880/764] max-xl:hidden" />
      )}
      <Swiper
        ref={swiperRef}
        slidesPerView={1}
        spaceBetween={32}
        loop={true}
        onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
        navigation={{
          prevEl: `.js-${swiperBtnClass}-prev`,
          nextEl: `.js-${swiperBtnClass}-next`,
        }}
        className="overflow-visible"
        pagination={{
          el: ".js-main-hero-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}"> <svg viewBox="0 0 32 32"><circle class="main-hero-bullet" r="5" cx="50%" cy="50%"/><circle class="main-hero-path-circle" r="15" cx="50%" cy="50%"/><circle class="main-hero-progress-circle progress-circle-${index}" r="15" cx="50%" cy="50%" /></svg> </span>`;
          },
        }}
        modules={[Navigation, Pagination, FreeMode]}
      >
        {banners.map((banner, index) => {
          return (
            <SwiperSlide key={banner.id} className={"relative overflow-hidden"}>
              <MovieBannerPlayer
                canvasRef={canvasRef}
                src={banner.bg_image.large}
                videoSrc={banner.teaser_link}
                index={index}
                goToDetail={() => goToDetail(banner.id)}
                slideNum={currentSlide}
                onVideoEnd={handleSlideChange}
              />
              <MovieBannerTop distributor={banner.distributor} is_new={banner.is_new} rating={banner.rating} />
              <MovieBannerTitle {...banner} showFavorite={index == currentSlide} />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div
        className={
          "absolute bottom-[2rem] left-1/2 z-[1] -translate-x-1/2 max-2xl:bottom-8 max-xl:bottom-5 max-lg:bottom-[-2rem] max-md:bottom-[-2.1rem]"
        }
      >
        <div className={"js-main-hero-pagination"} />
      </div>
      <MainHeroButtons btnClass={swiperBtnClass} />
    </section>
  );
};

export default MainHero;
